// removed by extract-text-webpack-plugin
module.exports = {"floatingInputWrapper":"index__floatingInputWrapper___26LKO","required":"index__required___M65Ua","toTop":"index__toTop___1OCYU","placeholder":"index__placeholder___39GJe","show":"index__show___8BdsS","default":"index__default___3AKs5","highlighted":"index__highlighted___3kg2W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/FloatingLabelInput/index.less
// module id = 1148
// module chunks = 3